<template>
  <div class="tes-articles-search" @mouseenter="enter" @mouseleave="leave">
    <form class="tes-articles-search__form" action="/" @submit.prevent="submit" autocomplete="off">
      <EllipsisLoader :loading="loading"/>
      <button type="button" @click="clear"
              class="tes-articles-search__button tes-articles-search__button_left"
              title="Очистить строку поиска поиска">
        <CrossIcon title="Иконка крестика" class="tes-articles-search__button-icon"/>
        <span class="not-for-anyone">Очистить строку поиска поиска</span>
      </button>
      <input v-model="searchWord" @input="search" @click="enter"
             type="text" placeholder="Поиск по статьям" name="s"
             class="tes-articles-search__input"
             title="Поле ввода текста для поиска по статьям"
             autocomplete="off"/>
      <button type="button" @click="search"
              class="tes-articles-search__button tes-articles-search__button_right" title="Запустить поиск по статьям">
        <SearchIcon title="Иконка поиска" class="tes-articles-search__button-icon"/>
        <span class="not-for-anyone">Запустить поиск по статьям</span>
      </button>
    </form>

    <div class="tes-articles-search__results" v-show="visibleResults">
      <div class="tes-articles-search__results-head tes-articles-search__text">Записи</div>
      <div class="tes-articles-search__results-body">
        <div v-if="posts.length === 0"
             class="tes-articles-search__results-item tes-articles-search__results-item_empty">
          <span class="tes-articles-search__text">ничего не найдено</span>
        </div>
        <div class="tes-articles-search__results-item" v-for="post in posts" v-else>
          <router-link class="tes-articles-search__results-item-link"
                       :to="{name: 'BlogPost', params: {tid: post.tid()}}">
            <span class="tes-articles-search__results-image-container">
            <img class="tes-articles-search__results-image"
                 :src="post.image()?.src()" :width="post.image()?.size().width()"
                 :height="post.image()?.size().height()"
                 :alt="post.image()?.alt()??''" v-if="post.image()"/>
            </span>
            <span class="tes-articles-search__results-description">
              <span class="tes-articles-search__text">{{ post.header() }}</span>
              <span class="tes-articles-search__text tes-articles-search__text_small">{{
                  post.publishedAt()?.toLocaleDateString('ru')
                }}</span>
            </span>
          </router-link>
        </div>

      </div>

      <div class="tes-articles-search__results-footer" v-if="posts.length > 0">
        <a :href="`/?s=${searchWord}`" class="tes-articles-search__results-footer-link">
          <span class="tes-articles-search__text">
            <span class="tes-articles-search__text tes-articles-search__text_highlight">Смотреть больше</span>&nbsp;
            <span class="tes-articles-search__text">по «{{ searchWord }}»</span>
          </span>
          <span class="tes-articles-search__text tes-articles-search__text_small"
                v-if="posts.length > 0">показано топ {{ posts.length }} результатов из {{ pagination.total() }}</span>
        </a>
      </div>

    </div>
  </div>
</template>

<script lang="ts">
import PostSearch from "../../composables/post-search"
import EllipsisLoader from "../loader/EllipsisLoader.vue"
import SearchIcon from '~/assets/icons/search-n.svg'
import CrossIcon from '~/assets/icons/cross.svg'

export default {
  name: 'PostsSearchForm',
  components: {EllipsisLoader, SearchIcon, CrossIcon},
  setup() {
    return PostSearch(10)
  }
}
</script>
